import React, { useEffect, useState } from "react";
import Modal from "../modal";
import { CLIENT_ACTION } from "../../redux/action";
import "./completeServiceFiledCopiesModal.scss";

export default function CompleteServiceFiledCopiesModal({
  open,
  clientId,
  clientServiceId,
  serviceCategory,
  clientBusinessId,
  submitting = false,
  onClose,
  onSubmit,
}) {
  const [documents, setDocuments] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !clientId) return undefined;
    let cancelled = false;
    setSelectedIds([]);
    setLoading(true);
    (async () => {
      const res = await CLIENT_ACTION.getUnassignedFiledCopies({
        client_id: clientId,
        client_service_id: clientServiceId,
        service_category: serviceCategory,
        client_business_id: clientBusinessId,
      });
      if (cancelled) return;
      const list = Array.isArray(res?.data) ? res.data : [];
      setDocuments(list);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [open, clientId, clientServiceId, serviceCategory, clientBusinessId]);

  if (!open) return null;

  const toggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  return (
    <Modal
      open
      title={null}
      handleClose={submitting ? () => {} : onClose}
      className="client-services-section__modal timesheet-view-modal"
    >
      <div className="my-services-modal-content">
        <div className="my-services-modal-header">
          <h3>Filed Copies</h3>
          <button
            type="button"
            className="my-services-modal-close"
            onClick={() => !submitting && onClose()}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <p className="complete-service-filed-copies__note">
          Filed Copies are optional. Select any for this service, or continue
          without one. Files already attached to another service are not shown.
        </p>
        {loading ? (
          <p className="complete-service-filed-copies__empty">Loading...</p>
        ) : documents.length === 0 ? (
          <p className="complete-service-filed-copies__empty">
            No Filed Copies are available for this service.
          </p>
        ) : (
          <ul className="complete-service-filed-copies__list">
            {documents.map((doc) => {
              const id = String(doc.client_document_id);
              return (
                <li key={id}>
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(id)}
                      onChange={() => toggle(id)}
                      disabled={submitting}
                    />
                    <span>{doc.document_name || "Document"}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        )}
        <div className="client-service-request-form__actions">
          <button
            type="button"
            className="client-service-request-form__cancel-btn"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="client-service-request-form__submit-btn"
            disabled={submitting}
            onClick={() => onSubmit(selectedIds)}
          >
            {submitting ? "Saving..." : "Submit"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
